import { useSetAtom } from "jotai";
import { useCallback } from "react";
import { MtgVibData, EachConditionData, NullableFloatArray, setEachConditionDataAtom } from "atoms/Rtool/mtgAtoms";
import { MTG_VIB_EACH_IDS } from "utils/consts";

type Status = 'notstarted' | 'loading' | 'success' | 'error';

/** null 許容 float 配列のショートハンド */
const E: NullableFloatArray = [];

/** 空の allConditionData を返すユーティリティ */
export function createEmptyAllConditionData(
    conditionIds: string[],
    initialStatus: Status = 'loading'
): Record<string, MtgVibData> {
    return conditionIds.reduce<Record<string, MtgVibData>>((acc, id) => {
        acc[id] = {
            data: { mtg_vib_target_squared_sum: [], vel: [], rpm: [] },
            status: initialStatus,
        };
        return acc;
    }, {});
};

export function useResetEachConditionData(initialStatus: Status = 'loading') {
    const resetAll = useSetAtom(setEachConditionDataAtom);

    return useCallback(() => {
        const payload: EachConditionData[] = MTG_VIB_EACH_IDS.map((graph_id) => ({
            graph_id,
            data: E,
            status: initialStatus,
        }))

        resetAll(...payload)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetAll])
};
